import { render, staticRenderFns } from "./LightSwitch.vue?vue&type=template&id=85743e9a&scoped=true"
import script from "./LightSwitch.vue?vue&type=script&lang=js"
export * from "./LightSwitch.vue?vue&type=script&lang=js"
import style0 from "./LightSwitch.vue?vue&type=style&index=0&id=85743e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85743e9a",
  null
  
)

export default component.exports